import { computed, getCurrentInstance } from '@vue/composition-api'

export default function useNominationLists() {
  const { proxy } = getCurrentInstance()
  proxy.$store.dispatch('nominations/fetchLists')
  return {
    listItems: computed(() => proxy.$store.getters['nominations/listItems']),
    defaultList: computed(() => proxy.$store.getters['nominations/defaultList'])
  }
}



// WEBPACK FOOTER //
// ./src/composables/nominations/useNominationLists.js